/**
 * Keys for run-scoped step status (must match backend StatusDetailsField).
 * @see rpt-backend/services/core/modules/python/types_util/project_data.py
 */

/** Sub-steps that require a successful file upload before Next can persist completed. */
export const UPLOAD_STEP_IDS = ['1.c', '2.b', '4.c'] as const;

/** Map dashboard uploader element ids (intl) to step keys used in step state and API. */
export function stepIdFromDashboardElementId(elementId: string): string {
  if (/^\d+\.[a-z]+$/.test(elementId)) {
    return elementId;
  }
  const match = /^steps\.(\d+\.[a-zA-Z])\./.exec(elementId);
  return match?.[1] ?? elementId;
}

export const ALL_RUN_STEP_STATUS_KEYS = [
  '1.a',
  '1.b',
  '1.c',
  '2.a',
  '2.b',
  '3.a',
  '3.b',
  '3.c',
  '4.a',
  '4.b',
  '4.c',
  '5',
] as const;

function firstIncompleteStepKey(
  stepMap: Record<string, unknown> | undefined
): (typeof ALL_RUN_STEP_STATUS_KEYS)[number] | null {
  if (!stepMap || typeof stepMap !== 'object') return null;
  for (const k of ALL_RUN_STEP_STATUS_KEYS) {
    if (String(stepMap[k]) !== 'completed') return k;
  }
  return null;
}

export function formatRunCurrentStepLabel(
  stepMap: Record<string, unknown> | undefined
): string | null {
  const key = firstIncompleteStepKey(stepMap);
  return key ? `Step ${key.replace('.', ' · ')}` : null;
}

export function isEveryRunStepCompleted(
  stepMap: Record<string, unknown> | undefined
): boolean {
  return firstIncompleteStepKey(stepMap) === null;
}
